import styled from 'styled-components';

export const DownloadAll = styled.span`
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 1em;
  cursor: pointer;
  color: #fff;
`;
